import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/pro-solid-svg-icons';
import OsEmbedRow from './os_embed_row';
import {
  blankVisualMedia,
  deleteVisualMedia,
  NewEmbedUi,
  updateVisualMedia,
  visualMediaId
} from './visual_media_shared';

export default function VisualMediaEmbeds({
  mediaTypeOptions,
  osRows,
  parentName,
  selectedVisualMediaIds,
  visualMediaEmbeds,
  onBulkCheckboxClick,
  onChange
}) {
  const handleVisualMediaEmbedsChange = newEmbeds => onChange(newEmbeds);

  const addVisualMediaEmbed = () => {
    handleVisualMediaEmbedsChange([...visualMediaEmbeds, blankVisualMedia(mediaTypeOptions)]);
  };

  const updateVisualMediaEmbed = (identifier, column, newValue) => {
    const newEmbeds = updateVisualMedia(visualMediaEmbeds, identifier, column, newValue);
    handleVisualMediaEmbedsChange(newEmbeds);
  };

  if (osRows) {
    return (
      <div className="d-flex flex-column gap-2">
        {visualMediaEmbeds.filter(embed => !embed.destroy).map((embed, index) => {
          const identifier = visualMediaId(embed);
          return (
            <OsEmbedRow
              embed={embed}
              index={index}
              isSelected={selectedVisualMediaIds.includes(identifier)}
              key={identifier}
              mediaTypeOptions={mediaTypeOptions}
              onChange={(column, value) => updateVisualMediaEmbed(identifier, column, value)}
              onDelete={() => handleVisualMediaEmbedsChange(deleteVisualMedia(visualMediaEmbeds, [identifier]))}
              onSelect={() => onBulkCheckboxClick(identifier)}
            />
          );
        })}
      </div>
    );
  }

  return (
    <Fragment>
      <div className="photo-grid">
        <button
          className="photo-row bg-white rounded border text-accent"
          style={{ minHeight: '250px' }}
          type="button"
          onClick={addVisualMediaEmbed}
        >
          <FontAwesomeIcon icon={faLink} size="xl"/>
          <div className="fs-large">Add Visual Media Link</div>
        </button>
        <NewEmbedUi
          mediaTypeOptions={mediaTypeOptions}
          parentName={parentName}
          selectedVisualMediaIds={selectedVisualMediaIds}
          updateVisualMediaEmbed={updateVisualMediaEmbed}
          visualMediaEmbeds={visualMediaEmbeds}
          onBulkCheckboxClick={onBulkCheckboxClick}
        />
      </div>
    </Fragment>
  );
}

VisualMediaEmbeds.propTypes = {
  mediaTypeOptions: PropTypes.array.isRequired,
  osRows: PropTypes.bool,
  parentName: PropTypes.string.isRequired,
  selectedVisualMediaIds: PropTypes.array.isRequired,
  visualMediaEmbeds: PropTypes.arrayOf(PropTypes.shape({
    embedUrl: PropTypes.string,
    fetchThumbnailUrl: PropTypes.string,
    mediaType: PropTypes.string,
    id: PropTypes.number,
    sortOrder: PropTypes.number,
  })),
  onBulkCheckboxClick: PropTypes.func.isRequired,
  onChange: PropTypes.func
};
